const Search = resolve => {
  require.ensure(["./search/index.vue"], () => {
    resolve(require("./search/index.vue"))
  }, "products")
}

const Reserves = resolve => {
  require.ensure(["./reserves/index.vue"], () => {
    resolve(require("./reserves/index.vue"))
  }, "products")
}

const ShowReserve = resolve => {
  require.ensure(["./reserves/show.vue"], () => {
    resolve(require("./reserves/show.vue"))
  }, "products")
}

export default class ProductsRouter {

    static addRoutes(appRoutes) {

      appRoutes.push({ path: "products/search", component: Search })
      appRoutes.push({ path: "products/reserves", component: Reserves })
      appRoutes.push({ path: "products/reserves/show/:branch/:id", component: ShowReserve })
    }
}
